import React, { useState, useEffect } from 'react';
import axios from 'axios';

const HotDealsPage = () => {
  const [hotDeals, setHotDeals] = useState([]);
  const [banner, setBanner] = useState(null);
  const [showBannerPopup, setShowBannerPopup] = useState(false);
  const [showDealPopup, setShowDealPopup] = useState(false);
  const [newDeal, setNewDeal] = useState({ product: '', price: '', img: null });
  const [newDealFiles, setDealsFiles] = useState(null); // For the banner file
  const [files, setFiles] = useState(null);
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [quantity, setQuantity] = useState('');
  const [number, setNumber] = useState('');
  useEffect(() => {
    fetchHotDeals();
    fetchBanner();
  }, []);

  const handleChange = (e) => {
    const selectedFiles = e.target.files;
    const selectedFile = selectedFiles[0];

    // Create FormData object
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('upload_preset', 'giweexpv'); // Your Cloudinary upload preset

    // Set the files state with the FormData object
    setFiles(formData);
  };

  const fetchHotDeals = async () => {
    try {
       
  
      const response = await axios.get('https://citi-mobile-app.onrender.com/admin/hotdeals');
      setHotDeals(response.data);
    } catch (error) {
      console.error('Error fetching hot deals:', error);
    }
  };

  const fetchBanner = async () => {
    try {
      const response = await axios.get('https://citi-mobile-app.onrender.com/admin/hotdeals/banner');
      setBanner(response.data);
    } catch (error) {
      console.error('Error fetching banner:', error);
    }
  };

  const handleBannerUpload = async () => {

    try {
        let imageUrl = ''; // Initialize image URL

        // Check if a new file is selected for upload
        if (files) {
          // Upload the new image to Cloudinary
          const response = await axios.post(
            'https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload',
            files
          );
          imageUrl = response.data.secure_url; // Get the URL of the uploaded image from Cloudinary response
        }

        console.log(imageUrl)
        await axios.post('https://citi-mobile-app.onrender.com/admin/hotdeal/banner', {
            imageUrl, // Send the image URL in the request body
          });
      fetchBanner(); // Refresh banner after upload
      setShowBannerPopup(false);
    } catch (error) {
      console.error('Error uploading banner:', error);
    }
  };

  const handleChangeDeal = (e) => {
    const selectedFiles = e.target.files;
    const selectedFile = selectedFiles[0];
  
    // Create FormData object for Cloudinary upload
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('upload_preset', 'giweexpv'); // Cloudinary upload preset
  
    // Set state for deal files
    setDealsFiles(formData);
  };
  
  const handleDealUpload = async () => {
    let imageUrl = ''; // Initialize image URL
  
    try {
      // Upload the image to Cloudinary
      if (newDealFiles) {
        const response = await axios.post(
          'https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload',
          newDealFiles
        );
        imageUrl = response.data.secure_url; // Get the URL of the uploaded image from Cloudinary response
      }
  
      // Now create a new FormData object to send to your backend
      const updatedData = {
        product: title,
        price: price,
        quantity: quantity,
        img: imageUrl, // Use the image URL
      };
      console.log(updatedData)
  
      // Now send the FormData to your backend
      await axios.post('https://citi-mobile-app.onrender.com/admin/upload/hotdeals', updatedData);
  
  
      fetchHotDeals(); // Refresh hot deals after upload
      setShowDealPopup(false); // Close the popup
    } catch (error) {
      console.error('Error uploading hot deal:', error);
    }
  };

  const handleDeleteDeal = async (id) => {
    try {
      // Call API to delete the deal by ID
      await axios.delete(`https://citi-mobile-app.onrender.com/admin/hotdeals/${id}`);
      fetchHotDeals(); // Refresh hot deals after deletion
    } catch (error) {
      console.error('Error deleting hot deal:', error);
    }
  };

  const handleEditDeal = (deal) => {
    setNewDeal(deal);
    setShowDealPopup(true);
  };

  return (
    <div className="container mx-auto max-w-[85%] mt-20 ml-60 max-sm:ml-0 max-sm:w-screen">
      <h1 className="text-2xl font-bold">Hot Deals</h1>

      {/* Banner Section */}
      <div className="my-5">
        <h2 className="text-xl mb-2">Hot deals banner</h2>
        {banner ? (
          <img src={banner.url} alt="Banner" className="w-[50%] h-40 object-cover" />
        ) : (
          <div className="w-[50%] h-40 bg-gray-200 mb-2" />
        )}
        <button
          className="bg-blue-500 text-white py-2 px-4 rounded"
          onClick={() => setShowBannerPopup(true)}
        >
          Change banner
        </button>
      </div>

      {/* Hot Deals Section */}
      <div className="my-5">
        <h2 className="text-xl mb-4">Hot deals</h2>
        <button
            className="border p-2 flex items-center justify-center"
            onClick={() => setShowDealPopup(true)}
          >
            + Add deal
          </button>
        <div className="grid grid-cols-4 gap-4">
          {hotDeals.map((deal) => (
            <div key={deal._id} className="relative border p-2">
              <img src={deal.img} alt={deal.product} className="w-full h-40 object-cover" />
              <p className="mt-2 text-center">{deal.product}</p>
              <p className="text-center font-bold">{deal.price}</p>
              <p className="text-center font-bold">{deal.quantity}</p>
              <button
                className="absolute top-2 right-2 bg-gray-200 p-1 rounded"
                onClick={() => handleEditDeal(deal)}
              >
                ✏️
              </button>
              {/* Delete Button */}
              <button
                className="absolute top-2 bg-red-500 text-white p-1 rounded"
                onClick={() => handleDeleteDeal(deal._id)}
              >
                🗑️
              </button>
            </div>
          ))}
         
        </div>
      </div>

      {/* Banner Upload Popup */}
      {showBannerPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded shadow-lg">
            <h2 className="text-xl font-bold mb-4">Upload Banner</h2>
            <input 
             type="file" 
             onChange={handleChange}/>
            <button
              onClick={handleBannerUpload}
              className="mt-4 bg-blue-500 text-white py-2 px-4 rounded"
            >
              Submit
            </button>
            <button
              onClick={() => setShowBannerPopup(false)}
              className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Hot Deal Upload/Edit Popup */}
      {showDealPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded shadow-lg">
            <h2 className="text-xl font-bold mb-4">
              {newDeal._id ? 'Edit Hot Deal' : 'Add Hot Deal'}
            </h2>
            <input
              type="text"
              placeholder="Product Name"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="border p-2 mb-4 w-full"
            />
            <input
              type="price"
              placeholder="Price"
              value={price}
            onChange={(e) => setPrice(e.target.value)}
              className="border p-2 mb-4 w-full"
            />
            <input
              type="quantity"
              placeholder="quantity"
              value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
              className="border p-2 mb-4 w-full"
            />
            
            <input
              type="file"
              onChange={handleChangeDeal}
              className="mb-4"
            />
            <button
              onClick={handleDealUpload}
              className="bg-blue-500 text-white py-2 px-4 rounded"
            >
              {newDeal._id ? 'Update' : 'Add'} Deal
            </button>
            <button
              onClick={() => setShowDealPopup(false)}
              className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotDealsPage;